import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import DOMPurify from 'dompurify';

const baseUrl = "https://api.shabdtoday.com/";
const image_resize = "https://api.shabdtoday.com/api/home/resize";

const isDesktopScreen = () => window.innerWidth >= 1024;
const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
        return text.substring(0, maxLength);
    }
    return text;
};

const truncateHtml = (html, maxLength) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";

    if (text.length <= maxLength) return html;

    let charCount = 0;
    let isTruncated = false;

    const traverse = (node) => {
        let newNode;
        if (node.nodeType === Node.TEXT_NODE) {
            if (charCount >= maxLength) return document.createTextNode("");
            const remaining = maxLength - charCount;
            const truncated = node.textContent.slice(0, remaining);
            charCount += truncated.length;
            if (charCount >= maxLength && !isTruncated) {
                isTruncated = true;
                newNode = document.createTextNode(truncated + "..."); // append dots
            } else {
                newNode = document.createTextNode(truncated);
            }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            newNode = node.cloneNode(false);
            node.childNodes.forEach((child) => {
                if (charCount < maxLength) {
                    newNode.appendChild(traverse(child));
                }
            });
        }
        return newNode;
    };

    const truncatedDiv = traverse(tempDiv);
    return truncatedDiv.outerHTML;
};


const local = "https://localhost:44351/api/home/bollywood"
const online = "https://api.shabdtoday.com/api/home/bollywood"
const clicklocal = "https://localhost:44351/api/home/update-viewcount"
const clickonline = "https://api.shabdtoday.com/api/home/update-viewcount"

const stripHtmlTags = (html, maxLength) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const strippedText = tempDiv.textContent || tempDiv.innerText || "";
    return truncateText(strippedText, maxLength);
};


function BollywoodCardsHome() {
    const [isDesktop, setIsDesktop] = useState(isDesktopScreen());
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const observer = useRef();

    const fetchNews = async () => {
        if (!hasMore || fetching) return;

        setFetching(true);
        try {
            const response = await axios.get(`${online}?page=${page}&limit=12`);

            if (response.data && response.data.bollywood.length > 0) {
                setNews((prevNews) => {
                    const existingIds = new Set(prevNews.map((item) => item.mainKhabarId));
                    const newNews = response.data.bollywood.filter((item) => !existingIds.has(item.mainKhabarId));
                    return [...prevNews, ...newNews];
                });
                setPage((prevPage) => prevPage + 1);
            } else {
                setHasMore(false);
            }
        } catch (error) {
            console.error("Error fetching news:", error.message);
        }
        setFetching(false);
        setLoading(false);
    };

    useEffect(() => {
        fetchNews();
    }, []);

    const handleNewsClick2 = async (slug, mainKhabarId) => {
        try {
            const response = await axios.post(`${clickonline}`, {
                mainKhabarId: mainKhabarId
            });

            if (response.status === 200) {
                // console.log("View count updated successfully", response.data);
                window.location.href = `/News-Details/${slug}`;
            } else {
                console.error("Failed to update view count", response.data);
            }
        } catch (error) {
            console.error("Error updating view count:", error.response ? error.response.data : error.message);
        }
    };

    const handleNewsClick = (trendingTagId) => {
        navigate(`/NewsDetails/${trendingTagId}`);
    };

    const generateShareLinks = (mainKhabarId, newsHeading) => {
        const encodedNewsHeading = encodeURIComponent(newsHeading);
        const url = `${window.location.origin}/News-Details/${mainKhabarId}`;
        return {
            facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encodedNewsHeading}`,
            whatsapp: `https://api.whatsapp.com/send?text=${encodedNewsHeading} ${url}`,
            twitter: `https://twitter.com/intent/tweet?text=${encodedNewsHeading}&url=${url}`,
            instagram: `https://www.instagram.com/`
        };
    };

    if (loading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                {/* <Circles height="30" width="30" color="#f7265c" ariaLabel="loading" visible={true} /> */}
            </div>
        );
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div>
            <div className="row vc_row">
                <div className="ak_vc_container">
                    <div className="wpb_column ak_column_3 vc_column_container">
                        <div className="ak_vc_wrapper wpb_wrapper">
                            <div
                                className="ak-block ak-block-list-2-wide ak-block-column ak-block-module-inner-boxed ak-block-inner-border-round ak-block-module-thumb-round ak-block-width-4 clearfix"
                                id="block_65f7f61f36732_2"
                            >
                                <div className="ak-block-inner clearfix">
                                    <div className="ak-block-posts clearfix">
                                        {news.map((post) => {
                                            const shareLinks = generateShareLinks(post.mainKhabarId, post.newsHeading);
                                            const htmlContent = isDesktop
                                                ? truncateHtml(post.newsTag, 100)
                                                : post.newsTag;
                                            return (

                                                <article key={post.mainKhabarId} className="ak-module ak-module-2-wide ak-column-module ak-module-meta-hide ak-module-excerpt-hide clearfix post-225 post type-post status-publish format-standard has-post-thumbnail  category-business category-entertainment category-tech-science category-work-life tag-breaking tag-election tag-politics tag-technology tag-world-news" style={{ border: "0.5px solid #d4d4d4ff", marginBottom: "20px" }}>
                                                    <div className="ak-module-inner clearfix">
                                                        <div className="ak-module-featured">
                                                            <div className="ak-module-details mb-4">
                                                                <h1 className="ak-module-title">
                                                                    <Link
                                                                        to={`/News-Details/${post.slug}`}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            handleNewsClick2(post.slug, post.mainKhabarId);
                                                                        }}
                                                                        rel="bookmark"
                                                                        aria-label="Shabd Today"
                                                                        title={stripHtmlTags(post.newsHeading)}
                                                                    >
                                                                        <span
                                                                            className="responsive-font"
                                                                            style={{ lineHeight: "30px" }}
                                                                            dangerouslySetInnerHTML={{ __html: htmlContent }}
                                                                        />
                                                                    </Link>
                                                                </h1>

                                                            </div>
                                                            <div className="ak-featured-cover">
                                                                <Link
                                                                    to={`/News-Details/${post.slug}`}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        handleNewsClick2(post.slug, post.mainKhabarId);
                                                                    }}
                                                                    className="ak-featured-link"
                                                                    rel="bookmark"
                                                                    aria-label="Shabd Today"
                                                                    title={stripHtmlTags(post.newsHeading, 150)}
                                                                >
                                                                    <div className="ak-featured-thumb  size-500">
                                                                        <img
                                                                            fetchpriority="high"
                                                                            decoding="async"
                                                                            width={410}
                                                                            height={300}
                                                                            loading="lazy"
                                                                            src={image_resize + "?url=" + baseUrl + post.newsImage + "&w=245&h=123&outtype=webp"}
                                                                            className="attachment-newsy_360x180 size-newsy_360x180 lazyload wp-post-image"
                                                                            alt={stripHtmlTags(post.newsHeading, 150)}
                                                                            data-src={image_resize + "?url=" + baseUrl + post.newsImage + "&w=245&h=123&outtype=webp"}
                                                                            data-sizes="auto"
                                                                            data-srcset={image_resize + "?url=" + baseUrl + post.newsImage + "&w=245&h=123&outtype=webp"}
                                                                            data-expand={700}
                                                                        />
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </article>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BollywoodCardsHome
